






















































import Vue from 'vue';
import _ from 'lodash';
import Requester from '../../requester';

import { ConsultaColetivaPutFormData } from '../../../../back/src/types';

import CustomDialog from '../CustomDialog.vue';

export default Vue.extend({
  name: 'ConsultaColetivaObservacoesDialog',
  props: {
    consultaColetiva: {
      default: null,
    },
  },
  components: {
    CustomDialog,
  },
  data() {
    return {
      loading: false,
      dialog: false,
      form: {
        observacoes: '',
      },
    };
  },
  computed: {
  },
  mounted() {
    this.form.observacoes = this.consultaColetiva.observacoes;
  },
  methods: {
    close() {
      this.dialog = false;
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm(): Promise<void> {
      const formData: ConsultaColetivaPutFormData = {
        id: this.consultaColetiva.id,
        observacoes: this.form.observacoes,
      };
      try {
        const response = await Requester.consultaColetiva.alteraConsultaColetiva(
          formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: ['Dados salvos.'] });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
        this.close();
      }
    },
  },
});
